import { acuityRequestsTyped } from "@/api/(requests)/acuityTyped";
import type { AcuityResolutionPayload, AcuityResolutionResponse, UUID } from "@/core/types";

export type AcuityResolutionVariables = {
  body: AcuityResolutionPayload;
  patientId: UUID;
};

export async function postAcuityResolution({
  body,
  patientId,
}: AcuityResolutionVariables): Promise<AcuityResolutionResponse> {
  return acuityRequestsTyped.post_acuity_resolution({
    body,
    context: { showLoader: false },
    urlParams: { patientId },
  });
}
